import { render, staticRenderFns } from "./ConfigContainer.vue?vue&type=template&id=53d9aa90&scoped=true"
import script from "./ConfigContainer.vue?vue&type=script&lang=js"
export * from "./ConfigContainer.vue?vue&type=script&lang=js"
import style0 from "./ConfigContainer.vue?vue&type=style&index=0&id=53d9aa90&prod&scoped=true&lang=scss"
import style1 from "./ConfigContainer.vue?vue&type=style&index=1&id=53d9aa90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d9aa90",
  null
  
)

export default component.exports